import styled from '@emotion/styled';
import { H3, SmallText } from 'ds/components/typography';

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(3)};
  ${({ theme }) => theme.media.showAt({ from: 3 })`
    width: 529px;
  `}
`;

export const TermsLink = styled.a(({ theme }) => ({
  fontSize: 13,
  lineHeight: '20px',
  color: theme.colors.neutrals.grey2,
  textDecoration: 'underline',
  '&:hover': {
    color: theme.colors.neutrals.grey1,
  },
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(1),
}));

export const HeaderBlock = styled.div(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%',
  textAlign: 'center',
}));

export const Headline = styled(H3.withComponent('div'))(({ theme }) => ({
  color: theme.colors.neutrals.grey1,
}));

export const Subtitle = styled(SmallText)(({ theme }) => ({
  color: theme.colors.neutrals.grey1,
  marginTop: theme.spacing(1),
}));
